
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppButton } from '@/components';
import { useLeagueRewardList } from '@/modules/league/tier/reward/model/list';
import { ROUTE_NAME_LEAGUE } from '@/modules/league/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_LEAGUE.TIER.REWARD.INDEX,
    components: { AppTable, AppCard, AppButton },
    setup() {
        const { list, total, fetchList, canAddNew, actions, routes } = useLeagueRewardList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'Position', key: 'position' },
                { type: TableColumnType.Text, label: 'Tier Reward', key: 'tierReward' },
                { type: TableColumnType.Text, label: 'Star Reward', key: 'starReward' },
                { type: TableColumnType.Text, label: 'Ruby Reward', key: 'rubyReward' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: routes.edit(row.position)
                    }),
                    canShow: (row: any) => row.canEdit,
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(row.position)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, fetchList, canAddNew, routes };
    }
});
